import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { PRODUCT_DETAILS_POST, IMAGE_ADDRESS } from '../../../../apis';
import apiRequest from '../../../../utils/apiRequest';
import { handleChangeDataPageProductDetails } from '../../../../redux/actions/pages/product/productDetails';
import { handleChangeDataSheetProductComments } from '../../../../redux/actions/pages/product/sheetProductComments';
import { handleChangeDataHeaderMobile } from '../../../../redux/actions/partials/header/headerMobile';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { actionAddToFavoriteList, actionRemoveFromFavoriteList } from '../../../../redux/actions/favorites';
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useCartHandlers } from '../../../../utils/cartHandler';
import { Sheet } from 'react-modal-sheet';

import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import StarYellow from '../../../../styles/images/png/star-yellow.webp';
import StarEmpty from '../../../../styles/images/svg/star-empty.svg';
import StarFill from '../../../../styles/images/svg/star-fill.svg';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import React from "react";
import { Link } from 'react-router-dom';
import IncredibleSVG from '../../../../styles/images/svg/IncredibleOffer.svg';
import SheetProductCommentsMobile from './sheetProductCommentsMobile';


const ProductMobile = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const { slug } = useParams();

	const { isBackdropLoading } = useSelector(state => state.allLoaders);
	const { product, variants, selectedSku, selectedSeller, categories, attributes, attributesFull, isShowAllAttributes, similarGoods, descriptionExpanded, isSheetAttributesOpen, isSheetSellersOpen, productComments } = useSelector(state => state.productDetails);
	const { carts } = useSelector(state => state.shoppingCart);
	const { favList } = useSelector(state => state.favoriteList);
	const isFav = favList && favList.find(fav => fav === slug);

	const selectedVariant = variants && variants.find(v => v.sku === selectedSku);
	const selectedSellerData = selectedVariant?.sellers.find(s => s.id === selectedSeller);
	const isInCart = carts && carts.find(cart => cart.sku === selectedVariant?.sku && cart.seller.id === selectedSellerData?.id);
	

	const handleChangeSku = (newSku) => {
		const newVariant = variants.find(v => v.sku === newSku);
	  	if (!newVariant) return;

	  	// آیا selectedSeller قبلی در این وریانت وجود دارد؟
	  	const matchedSeller = newVariant.sellers.find(s => s.id === selectedSeller);

	  	// اگر وجود دارد، همان را نگه داریم؛ اگر نه، اولین فروشنده را انتخاب کنیم
	  	const newSelectedSeller = matchedSeller ? matchedSeller.id : newVariant.sellers[0]?.id;

	  	// پیدا کردن فروشنده‌ای با کمترین قیمت
  		const minPrice = Math.min(...newVariant.sellers.map(s => parseInt(s.price)));

  		// پیدا کردن تمام فروشنده‌هایی که این قیمت رو دارن
  		const sellersWithMinPrice = newVariant.sellers.filter(s => parseInt(s.price) === minPrice);

  		// اگر فروشنده‌ی انتخاب‌شده فعلی در بین فروشنده‌هایی با کمترین قیمت بود، همون رو برگردون
  		const bestSeller = sellersWithMinPrice.find(s => s.id === newSelectedSeller)
    		|| sellersWithMinPrice[0]; // در غیر اینصورت اولینش


	  	// آپدیت وضعیت
	  	dispatch(handleChangeDataPageProductDetails('selectedSku', newSku));
	  	dispatch(handleChangeDataPageProductDetails('selectedSeller', newSelectedSeller));
	  	dispatch(handleChangeDataPageProductDetails('bestSeller', bestSeller));
	};


	useEffect(() => {
		callApiGetProductDetails();
	}, [ProductMobile, slug]);

	const callApiGetProductDetails = () => {
		if(! isBackdropLoading)
			apiRequest({
			    dispatch,
			    endpoint: (PRODUCT_DETAILS_POST),
			    data: {
			    	product: slug,
			    },
			    method: 'post',
			    onSuccess: (res) => {
			    	dispatch(handleChangeDataPageProductDetails('product', res.product));
			    	dispatch(handleChangeDataPageProductDetails('variants', res.variants));
			    	dispatch(handleChangeDataPageProductDetails('selectedSku', res.selectedSku));
			    	dispatch(handleChangeDataPageProductDetails('selectedSeller', res.selectedSeller));
			    	dispatch(handleChangeDataPageProductDetails('categories', res.categories));
			    	dispatch(handleChangeDataPageProductDetails('attributes', res.attributes));
			    	dispatch(handleChangeDataPageProductDetails('attributesFull', res.attributesFull));
			    	dispatch(handleChangeDataPageProductDetails('similarGoods', res.simillarProducts));
			    	dispatch(handleChangeDataPageProductDetails('productComments', res.productComments));

			    	{/**** dar surati k niyaz bashe "selectedSku" va "selectedSeller" az api hazf beshan, in block mitune samte server in 2 moteghayer ro set kone
			    	let bestVariant = null;
					let bestSeller = null;
					let minPrice = Infinity;

					res.variants.forEach(variant => {
					  	variant.sellers.forEach(seller => {
						    const price = parseInt(seller.price);
						    if (price < minPrice) {
						      	minPrice = price;
						      	bestVariant = variant;
						      	bestSeller = seller;
						    }
					  	});
					});
					// مقادیر پیش‌فرض برای وضعیت‌ها
					const defaultSelectedSku = bestVariant?.sku || null;
					const defaultSelectedSeller = bestSeller?.id || null;

					dispatch(handleChangeDataPageProductDetails('selectedSku', defaultSelectedSku));
				  	dispatch(handleChangeDataPageProductDetails('selectedSeller', defaultSelectedSeller));
				  	dispatch(handleChangeDataPageProductDetails('bestSeller', defaultSelectedSeller));

				  	ta inja *****/}
			    },
		  	});
	};

	const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};

	const toggleDescriptionExpanded = () => dispatch(handleChangeDataPageProductDetails('descriptionExpanded', !descriptionExpanded));
	const isLong = product.description !== null && product.description.length > 200;
  	const displayedDescriptionText = descriptionExpanded || !isLong ? product.description : product.description.substring(0, 200) + '...';


  	const closeBottomSheetAttribute = () => {
  		dispatch(handleChangeDataPageProductDetails('isSheetAttributesOpen', false));
  	};

  	const closeBottomSheetSellers = () => {
  		dispatch(handleChangeDataPageProductDetails('isSheetSellersOpen', false));
  	};

  	const toggleSheetAttributes = () => {
  		dispatch(handleChangeDataPageProductDetails('isSheetAttributesOpen', !isSheetAttributesOpen));
  	};

  	const toggleSheetSellers = () => {
  		dispatch(handleChangeDataPageProductDetails('isSheetSellersOpen', !isSheetSellersOpen));
  	};

  	const { handleAddToCart, handleMinusBtn } = useCartHandlers(selectedVariant, product, slug);




  	// State برای ذخیره زمان باقی‌مانده
  	const [time, setTime] = useState(
	  	(selectedSellerData?.inCampaign || selectedSellerData?.inFlashSale)
	    ? {
	        hours: selectedSellerData?.remainingTime?.hours || 0,
	        minutes: selectedSellerData?.remainingTime?.minutes || 0,
	        seconds: selectedSellerData?.remainingTime?.seconds || 0,
	      }
	    : { hours: 0, minutes: 0, seconds: 0 }
	);

  	// تابع برای کاهش زمان
  	const tick = () => {
	    setTime((prevTime) => {
	      	let { hours, minutes, seconds } = prevTime;

	      	if (seconds > 0) {
	        	seconds -= 1;
	      	} else if (minutes > 0) {
	        	seconds = 59;
	        	minutes -= 1;
	      	} else if (hours > 0) {
		        seconds = 59;
		        minutes = 59;
		        hours -= 1;
	      	} else {
		        // وقتی زمان به صفر رسید، تایمر متوقف می‌شود
		        return { hours: 0, minutes: 0, seconds: 0 };
	      	}

	      	return { hours, minutes, seconds };
	    });
  	};

  	// تنظیم تایمر با useEffect
  	useEffect(() => {
	    // اگر محصول در کمپین نیست، زمان را صفر کن
	    if (!selectedSellerData?.inCampaign && !selectedSellerData?.inFlashSale) {
	      	setTime({ hours: 0, minutes: 0, seconds: 0 });
	      	return;
	    }

	    // تنظیم زمان اولیه بر اساس selectedSellerData
	    setTime({
	      	hours: selectedSellerData.remainingTime.hours,
	      	minutes: selectedSellerData.remainingTime.minutes,
	      	seconds: selectedSellerData.remainingTime.seconds,
	    });

	    // ایجاد تایمر
	    const timer = setInterval(tick, 1000);

	    // پاکسازی تایمر هنگام تغییر فروشنده/رنگ یا unmount
	    return () => clearInterval(timer);
  	}, [selectedSeller]);


  	const showSheetProductComments = () => {
		dispatch( handleChangeDataSheetProductComments('isSheetProductsCommentOpen', true) );
	}

	const showSheetSearch = () => {
		dispatch(handleChangeDataHeaderMobile('isSheetSearchOpen', true));
	};

	const copyToClipboard = (text: string) => {
	  	if (navigator.clipboard) {
		    return navigator.clipboard.writeText(text);
	  	} else {
		    const textarea = document.createElement("textarea");
		    textarea.value = text;
		    textarea.style.position = "fixed";
		    textarea.style.opacity = "0";
		    document.body.appendChild(textarea);
		    textarea.select();
		    document.execCommand("copy");
		    document.body.removeChild(textarea);
		    return Promise.resolve();
	  	}
	};

	const handleShare = () => {
	  	copyToClipboard(window.location.href).then(() => {
		    // alert("لینک صفحه با موفقیت کپی شد ✅");
		    dispatch(
                handleSetOpenCustomSnackbar(true, {
                    message: "لینک صفحه با موفقیت کپی شد ✅",
                    severity: 'info',
                    vertical: 'bottom',
                    horizontal: 'center',
                })
            );
	  	});
	};

	const toggleFavorite = () => {
		if(isFav) 
			dispatch(actionRemoveFromFavoriteList(slug));
		else
			dispatch(actionAddToFavoriteList(slug));
	};

  	

    return (
    	
    	<div className="grow flex flex-col" style={{paddingBottom: '0px', paddingTop: '0px'}}>
			<div className="styles_BaseLayoutMobile__fixMobileHeader__eilSC">
				<div id="base_layout_mobile_static_header">
				</div>
			</div>
			<div className="grow bg-neutral-000 flex flex-col styles_BaseLayoutMobile__content__JgqoX">
				<div className="styles_PageLoader--hasPageContainer__gPBo1 hidden">
				</div>
				<div style={{paddingTop: '338px', userSelect: 'none'}}>
					<div className="w-full fixed top-0 left-0 z-3 bg-white">
						<div className="bg-white absolute -z-1 w-full overflow-auto hide-scrollbar transition-all w-full top-12" style={{transition: '0.1s', opacity: '0', pointerEvents: 'none'}}>
							<div className="flex relative w-fit" id="TAB_CONTAINER">
								<div className="pr-4 relative">
								</div>
								<div id="SPEC_tab" className="relative text-body1-strong text-neutral-500 py-2 px-3 cursor-pointer whitespace-nowrap !text-icon-high-emphasis">مشخصات
								</div>
								<div id="REVIEW_tab" className="relative text-body1-strong text-neutral-500 py-2 px-3 cursor-pointer whitespace-nowrap">بررسی تخصصی
								</div>
								<div id="COMMENTS_tab" className="relative text-body1-strong text-neutral-500 py-2 px-3 cursor-pointer whitespace-nowrap">دیدگاه و پرسش
								</div>
								<div id="SUGGESTION_tab" className="relative text-body1-strong text-neutral-500 py-2 px-3 cursor-pointer whitespace-nowrap">پیشنهاد ما
								</div>
								<div className="pr-4 relative">
								</div>
								<div className="bottom-0 absolute h-1 bg-black rounded-t" style={{transition: '0.1s', right: '24px', width: '58.0156px'}}>
								</div>
							</div>
						</div>
						<div className="flex justify-center items-center gap-2 !border-b-neutral-200 px-2 py-1 w-full bg-white z-2">
							<div className="flex justify-center items-center gap-1">
								<button onClick={() => navigate(-1)} className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--text__W2jhM styles_btn--primary__y0GEv rounded-medium p-2">
									<div className="flex items-center justify-center relative grow">
										<div className="flex">
											<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
												<use xlinkHref="#close"></use>
											</svg>
										</div>
									</div>
								</button>
							</div>
							<div className="flex-1 py-3">
							</div>
							<div className="flex justify-center items-center gap-1">
								<button onClick={showSheetSearch} className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--text__W2jhM styles_btn--primary__y0GEv rounded-medium p-2">
									<div className="flex items-center justify-center relative grow">
										<div className="flex">
											<div className="cube-font-icon" data-icon-name="cube-action-search" data-icon="" style={{width: '24px', height: '24px', fontSize: '24px', fontWeight: 'normal', color: 'var(--color-icon-high-emphasis)'}}>
											</div>
										</div>
									</div>
								</button>
								<div className="p-2 overflow-visible">
									<Link className="styles_Link__RMyqc" to="/checkout/cart/">
										<div className="flex relative">
											<div className="cube-font-icon" data-icon-name="cube-shop-cart-outline" data-icon="" style={{width: '24px', height: '24px', fontSize: '24px', fontWeight: 'normal', color: 'var(--color-icon-high-emphasis)'}}>
											</div>
											{ carts.length > 0 &&
												<span className="absolute flex items-center justify-center text-caption-strong styles_Icon__count__YizOQ text-neutral-000" style={{backgroundColor: 'var(--color-icon-primary)'}}>{toPersianDigits(carts.length)}
												</span>
											}
										</div>
									</Link>
									<div>
										<div>
										</div>
										<div className="z-4 text-body-2 styles_Tooltip__tooltip___Mj8o styles_Tooltip__tooltip__arrow--bottom-start__rvwG1 styles_Tooltip__tooltip--hasArrow___6xzR styles_Tooltip__tooltip--inactive__vFMA1" data-popper-reference-hidden="false" data-popper-escaped="false" data-popper-placement="bottom-start" style={{position: 'absolute', inset: '0px auto auto 0px', transform: 'translate(48px, 36px)'}}>رفتن به سبد خرید
											<div>
											</div>
										</div>
									</div>
								</div>
								{/* <div>
									<div>
										<button className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--text__W2jhM styles_btn--primary__y0GEv rounded-medium p-2">
											<div className="flex items-center justify-center relative grow">
												<div className="flex">
													<div className="cube-font-icon" data-icon-name="cube-nav-more-vert" data-icon="" style={{width: '24px', height: '24px', fontSize: '24px', fontWeight: 'normal', color: 'var(--color-icon-high-emphasis)'}}>
													</div>
												</div>
											</div>
										</button>
									</div>
									<div className="z-4 text-body-2 styles_Tooltip__tooltip___Mj8o styles_PdpMoreActionsTouchpoint__animation__37Ni1 styles_Tooltip__tooltip__arrow--bottom-start__rvwG1 styles_Tooltip__tooltip--hasArrow___6xzR styles_Tooltip__tooltip--inactive__vFMA1" data-popper-reference-hidden="false" data-popper-escaped="false" data-popper-placement="bottom-end" style={{position: 'absolute', inset: '0px 0px auto auto', transform: 'translate(-373px, 44px)'}}>
										<div className="flex items-center justify-center">
											<p className="text-body-2 text-white">افزودن به لیست ویژه بلک فرایدی
											</p>
											<div className="flex cursor-pointer pr-2">
												<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-white)'}}>
													<use xlinkHref="#close"></use>
												</svg>
											</div>
										</div>
										<div>
										</div>
									</div>
								</div> */}
							</div>
						</div>
					</div>
					<div id="gallery" className="fixed w-full top-12 left-0 z-1">
						<nav className="pt-0.5 pb-1.5 bg-white">
							<div className="flex overflow-x-auto overflow-y-hidden hide-scrollbar">
								<div className="pr-4">
								</div>
								<div className="flex justify-center items-center">
									<Link className="text-body-1 py-[3px] !font-medium text-neutral-500 whitespace-nowrap !underline underline-offset-[6px]" to="/">کوچی
									</Link>
									<div className="flex mx-[6px]">
										<div className="cube-font-icon" data-icon-name="cube-nav-chevron-left" data-icon="" style={{width: '12px', height: '12px', fontSize: '12px', fontWeight: 'normal', color: 'var(--color-icon-high-emphasis)'}}>
										</div>
									</div>
								</div>
								{
									categories && categories.map((cat, key) => (
										<div key={`top-cat-${key}`} className="flex justify-center items-center">
											<Link className="text-body-1 py-[3px] !font-medium text-neutral-500 whitespace-nowrap !underline underline-offset-[6px]" to={`/category/${cat.url}`}>{cat.title}
											</Link>
											<div className="flex mx-[6px]">
												<div className="cube-font-icon" data-icon-name="cube-nav-chevron-left" data-icon="" style={{width: '12px', height: '12px', fontSize: '12px', fontWeight: 'normal', color: 'var(--color-icon-high-emphasis)'}}>
												</div>
											</div>
										</div>
									))
								}
								<div className="pr-4">
								</div>
							</div>
						</nav>
						<div className="relative h-full bg-neutral-100 max-h-screen h-screen">
							<div className="relative">
								<Swiper className="hideNextPrev">

								{
									product.images.map((image, key) => {
										return (
											<SwiperSlide key={`pd-image-${key}`} style={{transitionDuration: '0ms', transform: 'translate3d(0px, 0px, 0px)'}}
												className="swiper-slide flex justify-center bg-neutral-100" >
												<div className="max-h-[250px] h-[250px] w-[250px]" style={{lineHeight: '0', mixBlendMode: 'multiply'}}>
													<LazyLoadImage src={IMAGE_ADDRESS + image} alt={product.title} className="w-full w-full h-full inline-block" style={{objectFit: 'cover'}} />
												</div>
											</SwiperSlide>
										);
									})
								}

								
								</Swiper>

								
							</div>
						</div>
					</div>
					<div id="content" className="z-2 relative bg-white border-complete-t rounded-t-lg overflow-hidden pb-3">
						<section id="SPEC">

							{ selectedSellerData && selectedSellerData.inCampaign &&
							<div class="w-full relative -mb-2">
								<div class="w-full absolute overflow-hidden z-1 flex h-10 rounded-t-[19px]" style={{top: '-1px', right: '-3px', width: 'calc(100% + 6px)'}}>
									<div class="w-full" style={{backgroundColor: 'rgb(242, 177, 190)'}}>
										<span class="w-full inline-block h-full" style={{width: '100%', transition: '1s', backgroundColor: 'rgb(231, 19, 61)'}}>
										</span>
									</div>
								</div>
								<div class="top-[3px] w-full text-body-1 flex justify-between items-center p-3 pb-5 relative z-2 rounded-t-lg" style={{backgroundColor: 'rgb(246, 229, 233)', color: 'rgb(231, 19, 61)'}}>
									<div class="flex items-center gap-1">
										<div style={{lineHeight: '0'}}>
											<img class="w-full inline-block" src={IncredibleSVG} alt="" title="" style={{objectFit: 'contain'}} />
										</div>
									</div>
									<div class="flex justify-center items-center gap-1">
										<div style={{color: 'rgb(231, 19, 61)'}}>
											<span class="text-body1-strong">{toPersianDigits(time.seconds)} : {toPersianDigits(time.minutes)} : {toPersianDigits(time.hours)}
											</span>
										</div>
										<div class="flex">
											<div class="cube-font-icon" data-icon-name="cube-action-time" data-icon="" style={{width: '16px', height: '16px', fontSize: '16px', fontWeight: 'normal', color: 'rgb(231, 19, 61)'}}>
											</div>
										</div>
									</div>
								</div>
							</div>
							}


							{ selectedSellerData && selectedSellerData.inFlashSale &&
							<div class="w-full relative -mb-2">
								<div class="w-full absolute overflow-hidden z-1 flex h-10 rounded-t-[19px]" style={{top: '-1px', right: '-3px', width: 'calc(100% + 6px)'}}>
									<div class="w-full" style={{backgroundColor: 'rgb(242, 177, 190)'}}>
										<span class="w-full inline-block h-full" style={{width: '100%', transition: '1s', backgroundColor: 'rgb(231, 19, 61)'}}>
										</span>
									</div>
								</div>
								<div class="top-[3px] w-full text-body-1 flex justify-between items-center p-3 pb-5 relative z-2 rounded-t-lg" style={{backgroundColor: 'rgb(246, 229, 233)', color: 'rgb(231, 19, 61)'}}>
									<div class="flex items-center gap-1">
										<div style={{lineHeight: '0'}}>
											{/*<img class="w-full inline-block" src={IncredibleSVG} alt="" title="" style={{objectFit: 'contain'}} />*/}
											<span style={{color: '#E6123D', fontSize: '25px'}}>
												حـــــــــــــــراج
											</span>
										</div>
									</div>
									<div class="flex justify-center items-center gap-1">
										<div style={{color: 'rgb(231, 19, 61)'}}>
											<span class="text-body1-strong">{toPersianDigits(time.seconds)} : {toPersianDigits(time.minutes)} : {toPersianDigits(time.hours)}
											</span>
										</div>
										<div class="flex">
											<div class="cube-font-icon" data-icon-name="cube-action-time" data-icon="" style={{width: '16px', height: '16px', fontSize: '16px', fontWeight: 'normal', color: 'rgb(231, 19, 61)'}}>
											</div>
										</div>
									</div>
								</div>
							</div>
							}


							<div className="bg-white rounded-t-lg relative z-3 overflow-hidden">
								<div className="flex justify-between px-4 pt-4 gap-4">
									<div className="flex justify-start items-center w-full overflow-hidden">
									{
										categories && categories.map((cat, key) => {
											return key === 0 ? (
												<Link className="text-body-1 !font-medium whitespace-nowrap overflow-hidden text-ellipsis shrink text-neutral-500 !underline underline-offset-[6px]" to={`category/${cat.url}`}>{cat.title}
												</Link>
											) : (
												<>
													<div className="flex mx-[6px]">
														<div className="cube-font-icon" data-icon-name="cube-nav-chevron-left" data-icon="" style={{width: '12px', height: '12px', fontSize: '12px', fontWeight: 'normal', color: 'var(--color-icon-high-emphasis)'}}>
														</div>
													</div>
													<Link className="text-body-1 !font-medium whitespace-nowrap overflow-hidden text-ellipsis shrink text-neutral-500 !underline underline-offset-[6px]" to={`category/${cat.url}`}>{cat.title}
													</Link>
												</>
											);
										})
									}
									</div>
									<div className="flex justify-center gap-2">
										<div onClick={handleShare} className="flex cursor-pointer cursor-pointer p-1.5">
											<div className="cube-font-icon" data-icon-name="cube-action-share" data-icon="" style={{width: '20px', height: '20px', fontSize: '20px', fontWeight: 'normal', color: 'var(--color-icon-high-emphasis)'}}>
											</div>
										</div>
										<div onClick={toggleFavorite} className="flex cursor-pointer cursor-pointer p-1.5 select-none" data-cro-id="pdp-favorite">
											<svg style={{width: '20px', height: '20px', fill: `${isFav ? "var(--color-icon-primary)" : "var(--color-icon-high-emphasis)"}`}}>
												{ isFav ?
													<use xlinkHref="#favoriteOn"></use>
													:
													<use xlinkHref="#favoriteOff"></use>
												}
											</svg>
										</div>
									</div>
								</div>
							</div>
							<div className="w-full flex flex-col items-start mt-3 mb-4 px-4">
								<div className="w-full"><h1 className="text-h5-180 relative text-neutral-850" style={{display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: '2', overflow: 'hidden'}}>{product.title}</h1>
								</div>
								<div className="overflow-auto hide-scrollbar max-w-[100vw] mt-3 gap-1.5 flex items-center">
									<div className="flex items-center">
										<div style={{width: '20px', height: '20px', lineHeight: '0'}}>
											<img className="w-full inline-block" src={StarYellow} width="20" height="20" alt="امتیاز" title="" style={{objectFit: 'contain'}} />
										</div>
										<p className="mr-1 text-body1-strong text-icon-high-emphasis">{toPersianDigits(product.rate)}
										</p>
										<p className="mr-1 text-body-1 text-icon-neutral-hint">({toPersianDigits(product.totalPoint)})
										</p>
									</div>
									<div className="flex gap-1.5 items-center whitespace-nowrap">
										<div className="flex items-center">
											<span className="inline-flex items-center cursor-pointer styles_Anchor--secondary__3KsgY text-body-2 cursor-pointer py-1.5" data-cro-id="pdp-comments-abovefold">
												<span>
													<span className="bg-gradient-silver flex item-center text-body2-strong-180 py-1 gap-0.5 pr-2 pl-1 text-icon-high-emphasis rounded-lg">{toPersianDigits(product.commentCount)} دیدگاه
														<div className="flex items-center">
															<div className="cube-font-icon" data-icon-name="cube-nav-chevron-left" data-icon="" style={{width: '16px', height: '16px', fontSize: '16px', fontWeight: 'normal', color: 'var(--color-icon-high-emphasis)'}}>
															</div>
														</div>
													</span>
												</span>
											</span>
										</div>
									</div>
									<div className="pl-6 h-1">
									</div>
								</div>
							</div>
							<hr className="w-full bg-neutral-100 border-none h-[1px]" />
							<div className="w-full flex flex-col gap-3 justify-center items-center py-5">
								<div className="w-full px-4 flex justify-between items-center">
									<span className="flex">
										<div className="flex items-center gap-1.5 text-h5">
											<span>
												{ selectedVariant && selectedVariant.attributeTile &&
													`${selectedVariant.attributeTile}: ${selectedVariant.optionTitle}`
												}
											</span>
											{ selectedVariant && selectedVariant.attributeTile && selectedVariant.optionColor &&
												<span className="w-4 h-4 rounded-circle border-complete-200" style={{backgroundColor: `#${selectedVariant.optionColor}`}}>
												</span>
											}
										</div>
									</span>
								</div>
								{ variants &&
								<div className="w-full">
									<div className="flex gap-2 overflow-auto hide-scrollbar">
										<div className="pr-2">
										</div>
										{
											variants.map((variant, key) => (
												<div key={`variant-${key}`} onClick={() => handleChangeSku(variant.sku)} className="py-0.5 cursor-pointer" >
													<div className={`select-none flex items-center justify-center gap-1.5 rounded-md pl-3 pr-2 whitespace-nowrap py-1.5 border-complete-200 min-w-[48px] ${variant.sku === selectedSku ? '!border-icon-high-emphasis' : ''}`}>
														<span className="w-5 h-5 rounded-circle border-complete-200 flex justify-center items-center" style={{backgroundColor: `#${variant.optionColor}`}}>
														{ variant.sku === selectedSku &&
															<div className="flex">
																<div className="cube-font-icon" data-icon-name="cube-cloud-check" data-icon="" style={{width: '14px', height: '14px', fontSize: '14px', fontWeight: 'normal', color: `${variant.optionColor === "000000" ? 'var(--color-icon-white)' : 'var(--color-icon-black)'}`}}>
																</div>
															</div>
														}
														</span>
														<span className="text-body-1-180 whitespace-nowrap text-neutral-650">{variant.optionTitle}
														</span>
													</div>
												</div>
											))
										}
										<div className="pr-2">
										</div>
									</div>
								</div>
								}
							</div>
							<hr className="w-full bg-neutral-100 border-none h-2" />
							<div id="PdpSeller" className="flex flex-col w-full pb-3">
								<div className="w-full flex justify-between items-center pt-5 px-4">
									<span className="text-h5-180 text-neutral-850">فروشنده
									</span>
									{ selectedVariant && selectedVariant.sellers.length > 1 &&
										<button onClick={toggleSheetSellers} class="font-iran-yekan relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--text__W2jhM styles_btn--black__xj6Mt rounded-medium">
											<div class="flex items-center justify-center relative grow">
												<span class="flex gap-1/5 justify-center items-center text-button-2 text-icon-high-emphasis">انتخاب از {toPersianDigits(selectedVariant.sellers.length - 1)} فروشنده دیگر
													<div class="flex">
														<div class="cube-font-icon" data-icon-name="cube-nav-chevron-left" data-icon="" style={{width: '18px', height: '18px', fontSize: '18px', fontWeight: 'normal', color: 'var(--color-icon-high-emphasis)'}}>		
														</div>
													</div>
												</span>
											</div>
										</button>
									}
								</div>
								{ selectedSellerData &&
								<Link className="flex justify-start items-center gap-3 px-4 py-0.5" to={`/seller/${selectedSellerData.id}/${selectedSellerData.title}`}>
									<div className="relative">
										<div className="flex p-2 rounded-circle bg-neutral-100">
											<div className="cube-font-icon" data-icon-name="cube-shop-seller" data-icon="" style={{width: '20px', height: '20px', fontSize: '20px', fontWeight: 'normal', color: 'var(--color-icon-high-emphasis)'}}>
											</div>
										</div>
									</div>
									<div className="flex gap-1 grow flex-col py-3 border-b border-neutral-100 w-full" style={{borderStyle: 'none none solid'}}>
										<div className="flex justify-start items-center w-full">
											<span className="text-button-2-180 text-neutral-900 ellipsis-1">{selectedSellerData.title}
											</span>
											<div className="flex">
												<div className="cube-font-icon" data-icon-name="cube-nav-chevron-left" data-icon="" style={{width: '16px', height: '16px', fontSize: '16px', fontWeight: 'normal', color: 'var(--color-icon-high-emphasis)'}}>
												</div>
											</div>
										</div>
										<div className="flex flex-wrap gap-1.5">
											<div className="text-body-1-compact text-neutral-900 whitespace-nowrap border-complete-200 rounded-lg pr-2 pl-0.5 py-0.5 flex gap-1.5 justify-center items-center">رضایت از کالا
												<span className="text-white text-body1-strong-compact rounded-lg px-2 py-0.5" style={{backgroundColor: 'var(--color-rating-0-2)'}}>{toPersianDigits(selectedSellerData.productRatePercent)}٪
												</span>
											</div>
											<div className="text-body-1-compact text-neutral-900 whitespace-nowrap border-complete-200 rounded-lg pr-2 pl-0.5 py-0.5 flex gap-1.5 justify-center items-center">عملکرد
												<span className="text-white text-body1-strong-compact rounded-lg px-2 py-0.5" style={{backgroundColor: 'var(--color-rating-4-5)'}}>{selectedSellerData.sellerPerformance}
												</span>
											</div>
										</div>
									</div>
								</Link>
								}



							</div>



						</section>
						<section id="REVIEW">
							<hr className="w-full bg-neutral-100 border-none h-2" />
							<div className="flex flex-col w-full items-center pb-5">
								<div className="w-full flex justify-between items-center pt-5 pb-3 px-5">
									<span className="text-h5-180 text-neutral-850">معرفی کالا
									</span>
								</div>
								<div className="flex flex-col w-full items-center gap-4">
									<p className="text-body-1 px-5" style={{display: '-webkit-box', WebkitBoxOrient: 'vertical'}}>{displayedDescriptionText}
									</p>
									<button onClick={toggleDescriptionExpanded} className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--text__W2jhM styles_btn--primary__y0GEv rounded-medium pr-4 pl-3 py-1.5 !rounded-lg !bg-neutral-100">
										<div className="flex items-center justify-center relative grow">
											<div className="flex justify-center items-center gap-2 text-body2-strong text-icon-high-emphasis" style={{fontFamily: 'IRANYekan'}}>{descriptionExpanded ? 'بستن' : 'بیشتر'}
												<div className="flex">
													<div className="cube-font-icon" data-icon-name="cube-nav-chevron-left" data-icon="" style={{width: '16px', height: '16px', fontSize: '16px', fontWeight: 'normal', color: 'var(--color-icon-high-emphasis)'}}>
													</div>
												</div>
											</div>
										</div>
									</button>
								</div>
							</div>
							<hr className="w-full bg-neutral-100 border-none h-[1px]" />
							{ attributesFull && attributesFull.length > 0  &&
								<div className="flex flex-col w-full pb-5">
									<h3 className="text-h5-180 text-neutral-850 pt-5 pb-3 px-5">جدول مشخصات
									</h3>
									<table className="mr-4 border-collapse mb-4">
										{
											attributesFull[0].items.map((attribute, key) => {
												if(key < 5)
													return (
														<tr className="border-complete-b-200">
															<th className="text-right text-body-1 py-1.5 px-2 whitespace-nowrap bg-neutral-100 align-top text-icon-high-emphasis">{attribute.attribute}
															</th>
															<td className="text-body-1 py-1.5 px-2 align-top text-icon-high-emphasis w-full">{attribute.value}
															</td>
														</tr>
													);
											})
										}
									</table>
									<div class="flex flex-col w-full items-center gap-4">
										<button onClick={toggleSheetAttributes} class="font-iran-yekan relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--text__W2jhM styles_btn--primary__y0GEv rounded-medium pr-4 pl-3 py-1.5 !rounded-lg !bg-neutral-100">
											<div class="flex items-center justify-center relative grow">
												<div class="flex justify-center items-center gap-2 text-body2-strong text-icon-high-emphasis">مشاهده ادامه مشخصات
													<div class="flex">
														<div class="cube-font-icon" data-icon-name="cube-nav-chevron-left" data-icon="" style={{width: '16px', height: '16px', fontSize: '16px', fontWeight: 'normal', color: 'var(--color-icon-high-emphasis)'}}>
														</div>
													</div>
												</div>
											</div>
										</button>
									</div>
								</div>
							}
						</section>
						<section id="COMMENTS">
							<hr className="w-full bg-neutral-100 border-none h-2" />
							<section className="relative overflow-hidden">
								<div className="hidden">
								</div>
								<div>
									<div className="flex flex-col px-4">
										<div className="flex items-center">
											<div className="break-words py-3 items-center">
												<div className="flex items-center grow">
													<h2 className="grow text-dark-neutral-000 text-h5">
														<span className="relative">دیدگاه کاربرها
														</span>
													</h2>
												</div>
											</div>
											<span onClick={showSheetProductComments} className="inline-flex items-center cursor-pointer styles_Anchor--n-650__j5s29 text-button-2 my-auto mr-auto">
												<span>مشاهده {toPersianDigits(productComments.length)} دیدگاه
												</span>
												<div className="flex">
													<ChevronLeftIcon sx={{width: '18px', height: '18px', fill: 'var(--color-icon-high-emphasis)'}} />
												</div>
											</span>
										</div>
										<div className="flex items-center">
											<span className="ml-1.5 text-h2-extra text-dark-neutral-000">{toPersianDigits(product.rate)}
											</span>
											<div style={{width: '20px', height: '20px', lineHeight: '0'}}>
												<img className="w-full inline-block" src={StarYellow} width="20" height="20" alt="" title="" style={{objectFit: 'contain'}} />
											</div>
											<span className="mr-1.5 text-body-2 text-dark-neutral-500">( بر اساس نظر {toPersianDigits(product.totalPoint)} خریدار )
											</span>
										</div>
									</div>

									{/*<div className="flex overflow-x-auto overflow-y-hidden hide-scrollbar pr-4 mb-4 gap-x-2">
										<div className="relative">
											<div data-cro-id="pdp-pics-in-comment" className="overflow-hidden border-complete  rounded overflow-hidden cursor-pointer object-cover shrink-0" style={{width: '80px', height: '80px', borderRadius: '8px', lineHeight: '0'}}>
												<img className="w-full bg-neutral-000 inline-block" src="" width="80" height="80" alt="" title="" style={{objectFit: 'cover', borderRadius: '8px'}} />
											</div>
										</div>
									</div>*/}
									<div>
										<div className="flex overflow-x-auto overflow-y-hidden hide-scrollbar mb-4 pr-4">
											{
												productComments.map((comment, key) => (
													<article key={`product-comments-${key}`} className="border-complete-200 rounded p-3 ml-2 flex flex-col h-50 w-60 xs:w-70 shrink-0">
														<div className="mb-2">
															<div className="flex items-center">
																<p className="text-body-2-compact text-neutral-650 whitespace-nowrap truncate overflow-hidden">{comment.userName}
																</p>
																<div className="inline-flex items-center mr-2 Badge_Badge__QIekq Badge_Badge--small__ElV6O px-2 text-caption-strong" style={{backgroundColor: 'rgba(76, 175, 80, 0.1)', color: 'var(--color-hint-text-success)'}}>
																	<p className="inline-block  text-caption-strong">خریدار
																	</p>
																</div>
															</div>
															<div>
																<div className="inline-flex flex-nowrap relative gap-x-0.5">
																	<div style={{width: '12px', height: '12px', lineHeight: '0'}}>
																		<img className="w-full inline-block" src={StarEmpty} width="12" height="12" alt="" title="" style={{objectFit: 'contain'}} />
																	</div>
																	<div style={{width: '12px', height: '12px', lineHeight: '0'}}>
																		<img className="w-full inline-block" src={StarEmpty} width="12" height="12" alt="" title="" style={{objectFit: 'contain'}} />
																	</div>
																	<div style={{width: '12px', height: '12px', lineHeight: '0'}}>
																		<img className="w-full inline-block" src={StarEmpty} width="12" height="12" alt="" title="" style={{objectFit: 'contain'}} />
																	</div>
																	<div style={{width: '12px', height: '12px', lineHeight: '0'}}>
																		<img className="w-full inline-block" src={StarEmpty} width="12" height="12" alt="" title="" style={{objectFit: 'contain'}} />
																	</div>
																	<div style={{width: '12px', height: '12px', lineHeight: '0'}}>
																		<img className="w-full inline-block" src={StarEmpty} width="12" height="12" alt="" title="" style={{objectFit: 'contain'}} />
																	</div>
																	<div className="absolute inset-0 overflow-hidden h-5" style={{width: `${parseFloat(comment.rate) * 100 / 5}%`}}>
																		<div className="absolute right-0 top-0 flex flex-nowrap gap-x-0.5">
																			<div style={{width: '12px', height: '12px', lineHeight: '0'}}>
																				<img className="w-full inline-block" src={StarFill} width="12" height="12" alt="" title="" style={{objectFit: 'contain'}} />
																			</div>
																			<div style={{width: '12px', height: '12px', lineHeight: '0'}}>
																				<img className="w-full inline-block" src={StarFill} width="12" height="12" alt="" title="" style={{objectFit: 'contain'}} />
																			</div>
																			<div style={{width: '12px', height: '12px', lineHeight: '0'}}>
																				<img className="w-full inline-block" src={StarFill} width="12" height="12" alt="" title="" style={{objectFit: 'contain'}} />
																			</div>
																			<div style={{width: '12px', height: '12px', lineHeight: '0'}}>
																				<img className="w-full inline-block" src={StarFill} width="12" height="12" alt="" title="" style={{objectFit: 'contain'}} />
																			</div>
																			<div style={{width: '12px', height: '12px', lineHeight: '0'}}>
																				<img className="w-full inline-block" src={StarFill} width="12" height="12" alt="" title="" style={{objectFit: 'contain'}} />
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
														<p className="text-body-1 text-neutral-700 ellipsis-3">{comment.comment}
														</p>
														<div className="flex items-center mt-auto">
															<p className="text-body-2 text-neutral-400">{toPersianDigits(comment.registerDate)}
															</p>
															{/*<div className="flex items-center text-neutral-500 pt-0 lg:justify-end mr-auto">
																<div className="mr-auto lg:mr-0 flex items-center">
																	<button className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 rounded-medium px-2 px-2 text-neutral-400" data-cro-id="pdp-comment-like">
																		<div className="flex items-center justify-center relative grow">
																			<p>۳۰
																			</p>
																			<div className="flex mr-1 text-neutral-400">
																				<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-low-emphasis)'}}>
																					<use xlinkHref="#thumbsUp"></use>
																				</svg>
																			</div>
																		</div>
																	</button>
																	<button className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 rounded-medium mr-1 px-2 text-neutral-400" data-cro-id="pdp-comment-dislike">
																		<div className="flex items-center justify-center relative grow">
																			<p>۳
																			</p>
																			<div className="flex mr-1 text-neutral-400">
																				<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-low-emphasis)'}}>
																					<use xlinkHref="#thumbsDown"></use>
																				</svg>
																			</div>
																		</div>
																	</button>
																</div>
															</div>*/}
														</div>
													</article>
												))
											}
											<div className="flex flex-col items-center justify-center px-10">
												<button onClick={showSheetProductComments} className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--outlined__saFC3 styles_btn--black__xj6Mt styles_btn--icon__7ZUM7 rounded-circle p-2">
													<div className="flex items-center justify-center relative grow">
														<div className="flex">
															<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-black)'}}>
																<use xlinkHref="#arrowLeft"></use>
															</svg>
														</div>
													</div>
												</button>
												<span className="whitespace-nowrap mt-2 text-caption-strong">مشاهده همه
												</span>
											</div>
										</div>
									</div>
									{/*<div data-cro-id="pdp-add-comment" className="px-4 border-complete-t">
										<div className="flex items-start mt-4">
											<span className="rounded-circle p-2 bg-neutral-100 ml-3">
												<div className="flex">
													<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-high-emphasis)'}}>
														<use xlinkHref="#comment"></use>
													</svg>
												</div>
											</span>
											<div className="flex grow items-start pb-2">
												<div>
													<p className="text-body1-strong text-neutral-650">دیدگاه خود را درباره این کالا بنویسید
													</p>
													<p className="text-neutral-400 text-body-2">با ثبت دیدگاه بر روی کالاهای خریداری شده ۵ امتیاز در دیجی‌کلاب دریافت کنید
													</p>
												</div>
												<div className="flex mr-auto pr-4">
													<ChevronLeftIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} />
												</div>
											</div>
										</div>
									</div>*/}
								</div>
							</section>
						</section>

						<section id="SUGGESTION" className="min-h-screen">
							<hr className="w-full bg-neutral-100 border-none h-2" />
							<div className="lazyload-wrapper ">
								<div>
									<div className="w-full z-3 py-2 bg-white">
										<h3 id="TABULAR_REF_ID" className="text-h5-compact text-neutral-850 pt-5 pb-3 px-4">پیشنهاد ما
										</h3>
										<div className="">
										</div>
										<div className="flex justify-start items-center gap-2 w-full overflow-auto hide-scrollbar">
											<div className="pr-2 h-1">
											</div>
											<div className="text-body-1-compact flex py-1">
												<div className="rounded-lg px-3 whitespace-nowrap max-w-[300px] ellipsis-1 py-1 select-none h-8 !flex items-center justify-center text-gray bg-icon-high-emphasis">کالاهای مشابه
												</div>
											</div>
											<div className="pr-2 h-1">
											</div>
										</div>
									</div>
									<div className="px-4 pb-5" id="tabs-container--top" style={{width: '405px'}}>
										<div className="relative">
											<div>
												<Swiper
													className="hideNextPrev"
													style={{ width: "100%" }} >
													<SwiperSlide>
														<div className="gap-x-2 gap-y-3 styles_ProductList__pagesContainer__kTouP styles_ProductList__pagesContainer--withoutSidebar__sDsrQ">
															{
																similarGoods && similarGoods.map((product, key) => (
																	<Link key={`similar-${key}`} className="w-full border-complete !border-neutral-200 rounded-md overflow-hidden"  to={`/product/${product.slug}/${product.title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`} >
																		<div className="bg-neutral-100">
																			<div className="w-full aspect-square" style={{lineHeight: '0', mixBlendMode: 'multiply'}}>
																				<picture>
																					<LazyLoadImage className="w-full inline-block" src={IMAGE_ADDRESS + product.image} alt={product.title} title="" style={{objectFit: 'cover'}} />
																				</picture>
																			</div>
																		</div>
																		<div className="p-2 !pt-1 flex flex-col w-full justify-between items-start">
																			<p className="text-body1-strong-180 text-neutral-650 h-9 s:h-11 w-full ellipsis-2">{product.title}
																			</p>
																			<div className="h-5 mb-1">
																				<div className="flex items-center justify-start gap-1 flex-wrap w-full h-5">
																					<div className="text-caption-strong px-2 flex items-center px-2 undefined style_ProductBadgesItem__4M3uG style_ProductBadges__customBadge__S17oh !bg-transparent !px-0 !text-icon-high-emphasis !text-caption">
																						<span>
																						</span>
																					</div>
																					<br />
																					<br />
																				</div>
																			</div>

																			<div>
																				{ product.discount  ?
																					<div className="flex items-center justify-start bg-red flex flex-col h-10.5 pt-0.5 !justify-start !items-start">
																						<div className="flex justify-start items-center gap-1">
																							<div className="px-1 text-white rounded-large flex items-center justify-center ProductPrice_ProductPrice__discountWrapper__1Ru_1 bg-hint-object-error shrink-0 !h-4">
																								<span className="text-body2-strong" data-testid="price-discount-percent">{toPersianDigits(product.discount)}٪
																								</span>
																							</div>
																							<span className="line-through text-body-2 ml-1 text-neutral-300 !leading-[16px]">{product.oldPrice && toPersianDigits(product.oldPrice)}
																							</span>
																						</div>
																						<div className="flex items-center justify-between">
																							<div className="flex items-center">
																								<span className="text-neutral-800 ml-0.5 text-h4 !leading-[24px]">{product.price !== null ? toPersianDigits(product.price) : 'ناموجود'}
																								</span>
																								{product.price &&
																									<div className="flex">
																										<svg style={{width: '14px', height: '14px', fill: 'var(--color-icon-high-emphasis)'}}>
																											<use xlinkHref="#toman"></use>
																										</svg>
																									</div>
																								}
																							</div>
																						</div>
																					</div>
																					:
																					<div className="flex items-center justify-start bg-red flex flex-col h-10.5 pt-0.5 !flex-row !justify-start !items-end">
																						<div className="flex justify-start items-center gap-1">
																							<span className="text-h4 ml-1 text-neutral-800 !leading-[16px]">{product.price !== null ? toPersianDigits(product.price) : 'ناموجود'}
																							</span>
																						</div>
																						<div className="flex items-center justify-between">
																							<div className="flex items-center">
																								{product.price &&
																									<div className="flex">
																										<svg style={{width: '14px', height: '14px', fill: 'var(--color-icon-high-emphasis)'}}>
																											<use xlinkHref="#toman"></use>
																										</svg>
																									</div>
																								}
																							</div>
																						</div>
																					</div>
																				}
																					
																			</div>
																		</div>
																	</Link>
																))
															}
														</div>
													</SwiperSlide>
												</Swiper>
											</div>
										</div>
									</div>
								</div>
							</div>
						</section>
						<section className="pb-18 pb-25" id="DKP">
							<hr className="w-full bg-neutral-100 border-none h-2" />
							<div className="w-full flex justify-center items-center gap-1.5 text-body1-strong-compact text-icon-high-emphasis pt-3">شناسه این کالا
								<span className="text-body2-strong py-1.5 px-4 flex justify-center items-center gap-1 bg-app-background rounded-full">DKP-18478157
									<div className="flex">
										<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-high-emphasis)'}}>
											<use xlinkHref="#copy"></use>
										</svg>
									</div>
								</span>
							</div>
						</section>
					</div>
					<div className="fixed bottom-0 left-0 w-screen bg-white z-2 border-complete-t !border-t-neutral-200">
						<div className="py-3 px-4">
							<div className="w-full flex justify-between gap-3 z-2 bg-white relative">
								{ isInCart === undefined ?
									<div className="flex items-center justify-between user-select-none w-2/3 !min-h-[48px] !max-h-[48px]">
										<button onClick={() => handleAddToCart(selectedSellerData)} className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--large__1Muai styles_btn--primary__y0GEv rounded-medium text-button-2 w-full" data-cro-id="pdp-add-to-cart" data-add-to-cart-variant-id="64672603" data-testid="add-to-cart">
											<div className="flex items-center justify-center relative grow">افزودن به سبد خرید
											</div>
										</button>
									</div>
									:
									<div class="flex items-center justify-between user-select-none w-1/2 gap-2 rounded-medium shadow-fab-button !min-h-[48px] !max-h-[48px]">
										<div onClick={() => handleAddToCart(selectedSellerData)} class="flex cursor-pointer flex items-center h-full p-3  p-0 lg:p-0">
											<svg data-testid="quantity-increase" data-cro-id="pdp-main-add-quantitiy" style={{width: '24px', height: '24px', fill: 'var(--color-icon-primary)'}}>
												<use xlinkHref="#addSimple"></use>
											</svg>
										</div>
										<span class="flex flex-col items-center justify-between text-primary-500">
											<span class="relative flex items-center justify-center text-h4 max-h-[20px] top-1">{toPersianDigits(isInCart.number)}
											</span>
										</span>
										<div onClick={() => handleMinusBtn(selectedSellerData)} class="flex cursor-pointer flex items-center h-full p-3">
											<svg data-testid="quantity-decrease" data-cro-id="pdp-main-delete-quantitiy" style={{width: '24px', height: '24px', fill: 'var(--color-icon-primary)'}}>
												<use xlinkHref={`#${isInCart.number > 1 ? 'removeSimple' : 'delete'}`}></use>
											</svg>
										</div>
									</div>
								}
								<div className="flex flex-col justify-center items-center w-1/3">
									<div className="w-full flex gap-1 item-center justify-end text-h3-bold-compact">
										<div className="w-4 min-w-[16px]">
										</div>{selectedSellerData && toPersianDigits(selectedSellerData.priceTxt)}
										<div className="flex flex justify-center items-center">
											<div className="cube-font-icon" data-icon-name="cube-value-toman" data-icon="" style={{width: '16px', height: '16px', fontSize: '16px', fontWeight: 'normal', color: 'var(--color-icon-high-emphasis)'}}>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>


			<SheetProductCommentsMobile />

			{ isSheetAttributesOpen && (
                <div
                    onClick={() => closeBottomSheetAttribute()}
                    style={{
                        position: 'fixed',
                        inset: 0,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        zIndex: 3,
                    }}
                />
            ) }

			<Sheet style={{zIndex: "4"}} isOpen={isSheetAttributesOpen} onClose={closeBottomSheetAttribute} detent="content-height" >
                <Sheet.Container >
                    <Sheet.Header className="">
                    	<div class="flex items-center px-5">
							<div class="break-words py-3 grow">
								<div class="flex items-center grow">
									<p class="grow text-h5 text-neutral-900">
										<span class="relative">مشخصات کالا</span>
									</p>
								</div>
							</div>
							<div class="grow text-h5">
							</div>
							<div class="flex cursor-pointer">
								<svg onClick={closeBottomSheetAttribute} style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
									<use xlinkHref="#close"></use>
								</svg>
							</div>
						</div>
                    </Sheet.Header>
                    <Sheet.Content>

                        <div class="px-4 pb-4 flex flex-col gap-1" style={{overflowY: 'auto'}}>
                        	{
                        		attributesFull && attributesFull.map((attribute, key) => (
                        			<>
                        			<p class="w-full text-h5 text-neutral-850 shrink-0 pb-3 pt-4">{attribute.category}</p>
                        			<table class="border-collapse">
                        				{
                        					attribute.items.map((item, itemKey) => (
                        						<tr class="border-complete-b-200">
													<th class="w-30 min-w-[120px] max-w-[120px] md:min-w-[180px] md:max-w-[180px] text-right text-body-1 py-1.5 px-2 bg-neutral-100 align-top text-icon-high-emphasis">{item.attribute}
													</th>
													<td class="text-body-1 py-1.5 px-2 align-top text-icon-high-emphasis w-full">{item.value} </td>
												</tr>
                        					))
                        				}
                        			</table>
                        			</>
                        		))
                        	}
                        </div>

                    </Sheet.Content>
                </Sheet.Container>
                <Sheet.Backdrop />
            </Sheet>



            { isSheetSellersOpen && (
                <div
                    onClick={() => closeBottomSheetSellers()}
                    style={{
                        position: 'fixed',
                        inset: 0,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        zIndex: 3,
                    }}
                />
            ) }

			<Sheet style={{zIndex: "4"}} isOpen={isSheetSellersOpen} onClose={closeBottomSheetSellers} detent="content-height" >
                <Sheet.Container >
                    <Sheet.Header className="">

                    	<div data-rsbs-header="true">
	                    	<div class="flex w-full justify-between items-center gap-3 mb-2 ">
								<div class="flex flex-col justify-center items-start">
									<p class="text-h5 text-neutral-700">فروشنده‌های این کالا</p>
									<p class="text-caption text-neutral-500">{selectedVariant && toPersianDigits(selectedVariant.sellers.length)} فروشنده</p>
								</div>
								<div class="flex cursor-pointer">
									<svg onClick={closeBottomSheetSellers} style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
										<use xlinkHref="#close"></use>
									</svg>
								</div>
							</div>
						</div>

                    </Sheet.Header>
                    <Sheet.Content>

                        <div data-rsbs-scroll="true">
							<div data-rsbs-content="true">
								<div class="flex flex-col p-4 gap-4">
									{ 
										selectedVariant && selectedVariant.sellers.length > 1 && selectedVariant.sellers.map((seller, key) => {
											const isThisSellerInCart = carts && carts.find(cart => cart.sku === selectedVariant?.sku && cart.seller.id === seller.id);

											return (
												<div key={`seller-sheet-${key}`} class="flex flex-col w-full border-complete-200 rounded-md relative overflow-hidden styles_sellerCard__ZUIYK" >
													<div class="flex flex-col w-full">
														<div class="w-full flex flex-col justify-center items-start pt-5 px-4">
															<span class="text-h5-compact text-neutral-850">فروشنده
															</span>
															{ seller.id === selectedSellerData.id &&
																<span class="text-body-1-180 text-icon-high-emphasis">شما در حال خرید از این فروشنده هستید
																</span>
															}
														</div>
														<Link class="flex justify-start items-start gap-3 px-4" to={`/seller/${seller.id}/${seller.title}`}>
															<div class="relative pt-1 xs:pt-1.5">
																<div class="flex p-2 rounded-circle bg-neutral-100">
																	<div class="cube-font-icon" data-icon-name="cube-shop-seller" data-icon="" style={{width: '20px', height: '20px', fontSize: '20px', fontWeight: 'normal', color: 'var(--color-icon-high-emphasis)'}}>
																	</div>
																</div>
																<div class="flex absolute left-1.5 bottom-1.5 bg-neutral-100">
																	<div class="cube-font-icon" data-icon-name="cube-badge-verified" data-icon="" style={{width: '12px', height: '12px', fontSize: '12px', fontWeight: 'normal', color: 'var(--color-rating-4-5)'}}>
																	</div>
																</div>
															</div>
															<div class="flex gap-1 grow flex-col py-3 border-b border-neutral-100" style={{borderStyle: 'none none solid'}}>
																<div class="flex justify-start items-center">
																	<span class="text-button-2 text-neutral-900">{seller.title}
																	</span>
																	<div class="flex">
																		<div class="cube-font-icon" data-icon-name="cube-nav-chevron-left" data-icon="" style={{width: '16px', height: '16px', fontSize: '16px', fontWeight: 'normal', color: 'var(--color-icon-high-emphasis)'}}>
																		</div>
																	</div>
																</div>
																<div class="flex flex-wrap gap-1.5">
																	<div class="text-body-1-compact text-neutral-900 whitespace-nowrap border-complete rounded-lg pr-1.5 pl-1 py-0.5 flex gap-1.5 justify-center items-center">رضایت از کالا
																		<span class="text-white text-body1-strong-compact rounded-lg px-2 py-0.5" style={{backgroundColor: 'var(--color-rating-4-5)'}}>{toPersianDigits(seller.productRatePercent)}٪
																		</span>
																	</div>
																	<div class="text-body-1-compact text-neutral-900 whitespace-nowrap border-complete rounded-lg pr-1.5 pl-1 py-0.5 flex gap-1.5 justify-center items-center">عملکرد
																		<span class="text-white text-body1-strong-compact rounded-lg px-2 py-0.5" style={{backgroundColor: 'var(--color-rating-4-5)'}}>{seller.sellerPerformance}
																		</span>
																	</div>
																</div>
															</div>
														</Link>

													</div>
													<div class="py-3 px-5 border-complete-t-200 flex justify-between items-center bg-white">
														<div class="min-w-6/12 shrink-0">
															{ isThisSellerInCart ?
																<div class="flex items-center justify-between user-select-none px-2 rounded-medium shadow-fab-button item-quantity_ItemQuantity__box__5r4FJ">
																	<div onClick={() => handleAddToCart(seller)} class="flex cursor-pointer p-0 lg:p-0">
																		<svg data-testid="quantity-increase" style={{width: '18px', height: '18px', fill: 'var(--color-icon-primary)'}}>
																			<use xlinkHref="#addSimple"></use>
																		</svg>
																	</div>
																	<span class="flex flex-col items-center justify-between text-primary-500">
																		<span class="relative flex items-center justify-center text-h5 item-quantity_ItemQuantity__boxCount__9ZT6i" style={{top: '0'}}>{toPersianDigits(isThisSellerInCart.number)}</span>
																	</span>
																	<div onClick={() => handleMinusBtn(seller)} class="flex cursor-pointer">
																		<svg data-testid="quantity-decrease" style={{width: '18px', height: '18px', fill: 'var(--color-icon-primary)'}}>
																			<use xlinkHref={`#${isThisSellerInCart.number > 1 ? 'removeSimple' : 'delete'}`}></use>
																		</svg>
																	</div>
																</div>
																:
																<button onClick={() => handleAddToCart(seller)} class="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--medium__4GoNC styles_btn--primary__y0GEv rounded-medium text-button-2 w-full"  >
																	<div class="flex items-center justify-center relative grow">افزودن به سبد خرید
																	</div>
																</button>
															}
														</div>
														<div>
															<div class="flex items-center justify-start mr-auto pr-4">
																<div class="flex justify-start items-center gap-1">
																	<span class="text-h4 ml-1 text-neutral-800">{seller.priceTxt && toPersianDigits(seller.priceTxt)}
																	</span>
																</div>
																<div class="flex items-center justify-between">
																	<div class="flex items-center">
																		<div class="flex">
																			<svg style={{width: '14px', height: '14px', fill: 'var(--color-icon-high-emphasis)'}}>
																				<use xlinkHref="#toman"></use>
																			</svg>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											);
										})
									}
								</div>
							</div>
						</div>

                    </Sheet.Content>
                </Sheet.Container>
                <Sheet.Backdrop />
            </Sheet>

		</div>

    );
}

export default ProductMobile;